import React from 'react';
import PropTypes from 'prop-types';
import AllocateBudget from './PlanningSteps/AllocateBudget';
import FundPlan from './PlanningSteps/FundPlan';
import SyndicationsPlan from './PlanningSteps/SyndicationsPlan';
import ReviewPlan from './PlanningSteps/ReviewPlan';
import BookCall from './PlanningSteps/BookCall';
import { FundType, steps } from '../constants';

const Content = ({ currentStep, setNextDisabled }) => {
  const renderContentItem = () => {
    switch (steps?.[currentStep]) {
      case 'AllocateBudget':
        return <AllocateBudget setNextDisabled={setNextDisabled} />;
      case 'CoreFundPlan':
        return (
          <FundPlan type={FundType.CORE} setNextDisabled={setNextDisabled} />
        );
      case 'FocusedFundPlan':
        return (
          <FundPlan type={FundType.FOCUSED} setNextDisabled={setNextDisabled} />
        );
      case 'FollowOnFundPlan':
        return (
          <FundPlan type={FundType.FOLLOW_ON} setNextDisabled={setNextDisabled} />
        );
      case 'SyndicationsPlan':
        return <SyndicationsPlan setNextDisabled={setNextDisabled} />;
      case 'ReviewPlan':
        return <ReviewPlan setNextDisabled={setNextDisabled} />;
      case 'BookCall':
        return <BookCall setNextDisabled={setNextDisabled} />;
      default:
        return <AllocateBudget setNextDisabled={setNextDisabled} />;
    }
  };

  return (
    <div>
      { renderContentItem() }
    </div>
  );
};

Content.propTypes = {
  currentStep: PropTypes.number.isRequired,
  setNextDisabled: PropTypes.func.isRequired,
};

export default Content;
